"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function trackEvent(name, parameters) {
    const dataLayer = window.dataLayer;
    if (dataLayer) {
        const event = Object.assign(Object.assign({}, parameters), { event: name });
        dataLayer.push(event);
    }
}
exports.default = trackEvent;
